import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "m23.3 20.69-2.11-6.83a1.34 1.34 0 0 0-.34-.56 2.62 2.62 0 0 0 .65-1.72V2.92A2.68 2.68 0 0 0 18.83.25H5.16A2.67 2.67 0 0 0 2.5 2.92v8.66a2.66 2.66 0 0 0 .64 1.72 1.46 1.46 0 0 0-.34.56L.73 20.61a2.17 2.17 0 0 0 1.94 3.14h18.66a2.15 2.15 0 0 0 1.84-1 2.11 2.11 0 0 0 .13-2.06m-7.8.46a.49.49 0 0 1-.4.21H8.9a.51.51 0 0 1-.41-.21.52.52 0 0 1-.07-.45L9 18.9a.5.5 0 0 1 .48-.35h5a.5.5 0 0 1 .47.35l.6 1.8a.49.49 0 0 1-.05.45M4.5 2.92a.67.67 0 0 1 .66-.67h13.67a.67.67 0 0 1 .67.67v8.66a.67.67 0 0 1-.67.67H5.16a.67.67 0 0 1-.66-.67Z"
    }, null, -1)
  ]));
}
const computerDeviceLaptop = { render };
export {
  computerDeviceLaptop as default,
  render
};
//# sourceMappingURL=computer-device-laptop.svg.js.map
